import imageUrlBuilder from '@sanity/image-url';
import client from '../groq/client';

function imageBuilder(source: ImageProps | PortableImageProps) {
  const gitSource = source as typeof source & {
    localizedAsset?: { src: string };
    localized?: { src: string };
  };
  const localized = gitSource.localizedAsset?.src || gitSource.localized?.src;
  if (!localized) return imageUrlBuilder(client).image(source);
  const url = new URL(localized, 'https://www.insiderfinance.io');
  if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Invalid editorial image URL');
  const builder = imageUrlBuilder().image(source);
  // Git assets are already rendered and hashed. Keep existing builder call sites.
  const result: typeof builder = new Proxy(builder, {
    get(target, field) {
      if (field === 'url' || field === 'toString') return () => localized;
      const value = Reflect.get(target, field);
      return typeof value === 'function' ? () => result : value;
    },
  });
  return result;
}
export const urlFor = (source: ImageProps) => imageBuilder(source);
export const urlForPortableImage = (source: PortableImageProps) => imageBuilder(source);
